import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function TermsPage() {
  const {
    language
  } = useLanguage();
  const isEnglish = language === 'en';
  return <div className="min-h-screen bg-gray-50" data-id="element-598">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-599">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-600">
          <a href="/" className="inline-flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-601">
            <ArrowLeft className="w-5 h-5" data-id="element-602" />
            <span className="font-medium" data-id="element-603">
              {isEnglish ? 'Back to Home' : "Retour à l'accueil"}
            </span>
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-604">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 sm:p-12" data-id="element-605">
          {isEnglish ? <EnglishTerms data-id="element-606" /> : <FrenchTerms data-id="element-607" />}
        </div>
      </main>
    </div>;
}
function FrenchTerms() {
  return <>
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-608">
        Conditions Générales d'Utilisation
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-609">
        Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
      </p>

      <div className="prose prose-gray max-w-none" data-id="element-610">
        <section className="mb-8" data-id="element-611">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-612">
            1. Présentation du Service
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-613">
            AfriCard Compare est un service de comparaison gratuit qui permet
            aux utilisateurs de comparer les frais et taux de change de
            différents prestataires de transfert d'argent en Afrique de l'Ouest
            (Djamo CI, Djamo SN, Wave, PushCI, Orange Money Senegal, Nafolo CI).
          </p>
          <p className="text-gray-700 leading-relaxed" data-id="element-614">
            Le service est fourni à titre informatif uniquement. Nous ne sommes
            pas un prestataire de services financiers et ne facilitons aucune
            transaction financière.
          </p>
        </section>

        <section className="mb-8" data-id="element-615">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-616">
            2. Acceptation des Conditions
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-617">
            En utilisant AfriCard Compare, vous acceptez d'être lié par ces
            Conditions Générales d'Utilisation. Si vous n'acceptez pas ces
            conditions, veuillez ne pas utiliser notre service.
          </p>
        </section>

        <section className="mb-8" data-id="element-618">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-619">
            3. Utilisation du Service
          </h2>
          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-620">
            3.1 Accès Gratuit
          </h3>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-621">
            L'accès à AfriCard Compare est entièrement gratuit. Nous ne
            facturons aucun frais pour l'utilisation de notre outil de
            comparaison.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-622">
            3.2 Utilisation Autorisée
          </h3>
          <p className="text-gray-700 leading-relaxed mb-2" data-id="element-623">
            Vous vous engagez à utiliser le service uniquement à des fins
            légales et conformément à ces conditions. Il est interdit de :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-624">
            <li data-id="element-625">Utiliser le service à des fins frauduleuses ou illégales</li>
            <li data-id="element-626">Tenter de perturber ou d'endommager le service</li>
            <li data-id="element-627">
              Extraire automatiquement des données (scraping) sans autorisation
            </li>
            <li data-id="element-628">Usurper l'identité d'une autre personne ou entité</li>
            <li data-id="element-629">Diffuser du contenu malveillant ou des virus</li>
          </ul>
        </section>

        <section className="mb-8" data-id="element-630">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-631">
            4. Informations et Taux de Change
          </h2>
          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-632">
            4.1 Exactitude des Informations
          </h3>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-633">
            Nous nous efforçons de fournir des informations exactes et à jour
            concernant les taux de change et les frais des prestataires.
            Cependant, nous ne garantissons pas l'exactitude, l'exhaustivité ou
            l'actualité de ces informations.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-634">
            4.2 Variations des Taux
          </h3>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-635">
            Les taux de change et les frais affichés sont susceptibles de
            changer sans préavis. Les taux réels appliqués lors d'une
            transaction peuvent différer de ceux affichés sur notre plateforme.
            Nous vous recommandons de vérifier les taux directement auprès du
            prestataire avant d'effectuer une transaction.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-636">
            4.3 Aucune Garantie
          </h3>
          <p className="text-gray-700 leading-relaxed" data-id="element-637">
            AfriCard Compare ne garantit pas que les informations fournies sont
            exemptes d'erreurs. Nous déclinons toute responsabilité en cas de
            perte ou de dommage résultant de l'utilisation des informations
            fournies sur notre plateforme.
          </p>
        </section>

        <section className="mb-8" data-id="element-638">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-639">
            5. Limitation de Responsabilité
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-640">
            AfriCard Compare est un service de comparaison uniquement. Nous ne
            sommes pas responsables :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-641">
            <li data-id="element-642">
              Des transactions effectuées avec les prestataires de services
            </li>
            <li data-id="element-643">
              Des pertes financières résultant de l'utilisation de notre service
            </li>
            <li data-id="element-644">Des erreurs ou omissions dans les informations affichées</li>
            <li data-id="element-645">De l'indisponibilité temporaire ou permanente du service</li>
            <li data-id="element-646">Des actions ou politiques des prestataires tiers</li>
          </ul>
          <p className="text-gray-700 leading-relaxed" data-id="element-647">
            Dans la mesure maximale autorisée par la loi, notre responsabilité
            totale envers vous pour toute réclamation découlant de l'utilisation
            du service ne dépassera pas 0 € (zéro euro).
          </p>
        </section>

        <section className="mb-8" data-id="element-648">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-649">
            6. Propriété Intellectuelle
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-650">
            Tout le contenu présent sur AfriCard Compare (textes, graphiques,
            logos, images, code source) est la propriété d'AfriCard Compare ou
            de ses concédants de licence et est protégé par les lois sur la
            propriété intellectuelle.
          </p>
          <p className="text-gray-700 leading-relaxed" data-id="element-651">
            Vous ne pouvez pas reproduire, distribuer, modifier ou créer des
            œuvres dérivées de notre contenu sans autorisation écrite préalable.
          </p>
        </section>

        <section className="mb-8" data-id="element-652">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-653">
            7. Liens vers des Sites Tiers
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-654">
            Notre service peut contenir des liens vers des sites web de
            prestataires tiers. Nous ne contrôlons pas ces sites et ne sommes
            pas responsables de leur contenu, de leurs politiques de
            confidentialité ou de leurs pratiques. L'accès à ces sites se fait à
            vos propres risques.
          </p>
        </section>

        <section className="mb-8" data-id="element-655">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-656">
            8. Collecte de Données et Confidentialité
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-657">
            Nous collectons des données analytiques anonymes pour améliorer
            notre service (via Mixpanel). Ces données incluent :
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-658">
            <li data-id="element-659">
              Les comparaisons effectuées (montants, devises, prestataires)
            </li>
            <li data-id="element-660">La langue sélectionnée</li>
            <li data-id="element-661">Les pages visitées</li>
          </ul>
          <p className="text-gray-700 leading-relaxed" data-id="element-662">
            Pour plus d'informations, consultez notre{' '}
            <a href="/privacy" className="text-blue-600 hover:text-blue-700 underline" data-id="element-663">
              Politique de Confidentialité
            </a>
            .
          </p>
        </section>

        <section className="mb-8" data-id="element-664">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-665">
            9. Modifications des Conditions
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-666">
            Nous nous réservons le droit de modifier ces Conditions Générales
            d'Utilisation à tout moment. Les modifications entreront en vigueur
            dès leur publication sur cette page. Votre utilisation continue du
            service après la publication des modifications constitue votre
            acceptation des nouvelles conditions.
          </p>
        </section>

        <section className="mb-8" data-id="element-667">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-668">
            10. Résiliation
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-669">
            Nous nous réservons le droit de suspendre ou de résilier votre accès
            au service à tout moment, sans préavis, si nous estimons que vous
            avez violé ces conditions ou pour toute autre raison à notre seule
            discrétion.
          </p>
        </section>

        <section className="mb-8" data-id="element-670">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-671">
            11. Droit Applicable et Juridiction
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-672">
            Ces Conditions Générales d'Utilisation sont régies par le droit
            français. Tout litige relatif à l'interprétation ou à l'exécution de
            ces conditions sera soumis à la compétence exclusive des tribunaux
            français.
          </p>
        </section>

        <section className="mb-8" data-id="element-673">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-674">12. Contact</h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-675">
            Pour toute question concernant ces Conditions Générales
            d'Utilisation, vous pouvez nous contacter :
          </p>
          <ul className="list-none text-gray-700 space-y-2" data-id="element-676">
            <li data-id="element-677">
              <strong data-id="element-678">Par WhatsApp :</strong>{' '}
              <a href="https://wa.me/2250700592164" className="text-blue-600 hover:text-blue-700 underline" target="_blank" rel="noopener noreferrer" data-id="element-679">
                +225 07 00 59 21 64
              </a>
            </li>
            <li data-id="element-680">
              <strong data-id="element-681">Email :</strong>{' '}
              <a href="mailto:contact@africardcompare.com" className="text-blue-600 hover:text-blue-700 underline" data-id="element-682">
                contact@africardcompare.com
              </a>
            </li>
          </ul>
        </section>

        <div className="mt-12 p-6 bg-gray-50 rounded-lg border border-gray-200" data-id="element-683">
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-684">
            <strong data-id="element-685">Avertissement :</strong> AfriCard Compare est un outil de
            comparaison indépendant. Nous ne sommes affiliés à aucun des
            prestataires de services mentionnés. Les marques et logos affichés
            appartiennent à leurs propriétaires respectifs. Toutes les
            transactions financières sont effectuées directement entre vous et
            le prestataire choisi.
          </p>
        </div>
      </div>
    </>;
}
function EnglishTerms() {
  return <>
      <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-686">
        Terms and Conditions
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-687">
        Last updated: {new Date().toLocaleDateString('en-US')}
      </p>

      <div className="prose prose-gray max-w-none" data-id="element-688">
        <section className="mb-8" data-id="element-689">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-690">
            1. Service Overview
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-691">
            AfriCard Compare is a free comparison service that allows users to
            compare fees and exchange rates of different money transfer
            providers in West Africa (Djamo CI, Djamo SN, Wave, PushCI, Orange
            Money Senegal, Nafolo CI).
          </p>
          <p className="text-gray-700 leading-relaxed" data-id="element-692">
            The service is provided for informational purposes only. We are not
            a financial service provider and do not facilitate any financial
            transactions.
          </p>
        </section>

        <section className="mb-8" data-id="element-693">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-694">
            2. Acceptance of Terms
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-695">
            By using AfriCard Compare, you agree to be bound by these Terms and
            Conditions. If you do not accept these terms, please do not use our
            service.
          </p>
        </section>

        <section className="mb-8" data-id="element-696">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-697">
            3. Use of Service
          </h2>
          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-698">
            3.1 Free Access
          </h3>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-699">
            Access to AfriCard Compare is completely free. We do not charge any
            fees for using our comparison tool.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-700">
            3.2 Permitted Use
          </h3>
          <p className="text-gray-700 leading-relaxed mb-2" data-id="element-701">
            You agree to use the service only for lawful purposes and in
            accordance with these terms. It is prohibited to:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-702">
            <li data-id="element-703">Use the service for fraudulent or illegal purposes</li>
            <li data-id="element-704">Attempt to disrupt or damage the service</li>
            <li data-id="element-705">Automatically extract data (scraping) without authorization</li>
            <li data-id="element-706">Impersonate another person or entity</li>
            <li data-id="element-707">Distribute malicious content or viruses</li>
          </ul>
        </section>

        <section className="mb-8" data-id="element-708">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-709">
            4. Information and Exchange Rates
          </h2>
          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-710">
            4.1 Accuracy of Information
          </h3>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-711">
            We strive to provide accurate and up-to-date information regarding
            exchange rates and provider fees. However, we do not guarantee the
            accuracy, completeness, or timeliness of this information.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-712">
            4.2 Rate Variations
          </h3>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-713">
            Exchange rates and fees displayed are subject to change without
            notice. Actual rates applied during a transaction may differ from
            those displayed on our platform. We recommend verifying rates
            directly with the provider before making a transaction.
          </p>

          <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6" data-id="element-714">
            4.3 No Warranty
          </h3>
          <p className="text-gray-700 leading-relaxed" data-id="element-715">
            AfriCard Compare does not warrant that the information provided is
            error-free. We disclaim all liability for any loss or damage
            resulting from the use of information provided on our platform.
          </p>
        </section>

        <section className="mb-8" data-id="element-716">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-717">
            5. Limitation of Liability
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-718">
            AfriCard Compare is a comparison service only. We are not
            responsible for:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-719">
            <li data-id="element-720">Transactions made with service providers</li>
            <li data-id="element-721">Financial losses resulting from the use of our service</li>
            <li data-id="element-722">Errors or omissions in displayed information</li>
            <li data-id="element-723">Temporary or permanent unavailability of the service</li>
            <li data-id="element-724">Actions or policies of third-party providers</li>
          </ul>
          <p className="text-gray-700 leading-relaxed" data-id="element-725">
            To the maximum extent permitted by law, our total liability to you
            for any claims arising from the use of the service shall not exceed
            €0 (zero euros).
          </p>
        </section>

        <section className="mb-8" data-id="element-726">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-727">
            6. Intellectual Property
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-728">
            All content on AfriCard Compare (text, graphics, logos, images,
            source code) is the property of AfriCard Compare or its licensors
            and is protected by intellectual property laws.
          </p>
          <p className="text-gray-700 leading-relaxed" data-id="element-729">
            You may not reproduce, distribute, modify, or create derivative
            works from our content without prior written permission.
          </p>
        </section>

        <section className="mb-8" data-id="element-730">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-731">
            7. Links to Third-Party Sites
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-732">
            Our service may contain links to third-party provider websites. We
            do not control these sites and are not responsible for their
            content, privacy policies, or practices. Access to these sites is at
            your own risk.
          </p>
        </section>

        <section className="mb-8" data-id="element-733">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-734">
            8. Data Collection and Privacy
          </h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-735">
            We collect anonymous analytics data to improve our service (via
            Mixpanel). This data includes:
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-736">
            <li data-id="element-737">Comparisons made (amounts, currencies, providers)</li>
            <li data-id="element-738">Selected language</li>
            <li data-id="element-739">Pages visited</li>
          </ul>
          <p className="text-gray-700 leading-relaxed" data-id="element-740">
            For more information, see our{' '}
            <a href="/privacy" className="text-blue-600 hover:text-blue-700 underline" data-id="element-741">
              Privacy Policy
            </a>
            .
          </p>
        </section>

        <section className="mb-8" data-id="element-742">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-743">
            9. Changes to Terms
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-744">
            We reserve the right to modify these Terms and Conditions at any
            time. Changes will take effect upon posting on this page. Your
            continued use of the service after changes are posted constitutes
            your acceptance of the new terms.
          </p>
        </section>

        <section className="mb-8" data-id="element-745">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-746">
            10. Termination
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-747">
            We reserve the right to suspend or terminate your access to the
            service at any time, without notice, if we believe you have violated
            these terms or for any other reason at our sole discretion.
          </p>
        </section>

        <section className="mb-8" data-id="element-748">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-749">
            11. Governing Law and Jurisdiction
          </h2>
          <p className="text-gray-700 leading-relaxed" data-id="element-750">
            These Terms and Conditions are governed by French law. Any dispute
            relating to the interpretation or execution of these terms shall be
            subject to the exclusive jurisdiction of French courts.
          </p>
        </section>

        <section className="mb-8" data-id="element-751">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-752">12. Contact</h2>
          <p className="text-gray-700 leading-relaxed mb-4" data-id="element-753">
            For any questions regarding these Terms and Conditions, you can
            contact us:
          </p>
          <ul className="list-none text-gray-700 space-y-2" data-id="element-754">
            <li data-id="element-755">
              <strong data-id="element-756">Via WhatsApp:</strong>{' '}
              <a href="https://wa.me/2250700592164" className="text-blue-600 hover:text-blue-700 underline" target="_blank" rel="noopener noreferrer" data-id="element-757">
                +225 07 00 59 21 64
              </a>
            </li>
            <li data-id="element-758">
              <strong data-id="element-759">Email:</strong>{' '}
              <a href="mailto:contact@africardcompare.com" className="text-blue-600 hover:text-blue-700 underline" data-id="element-760">
                contact@africardcompare.com
              </a>
            </li>
          </ul>
        </section>

        <div className="mt-12 p-6 bg-gray-50 rounded-lg border border-gray-200" data-id="element-761">
          <p className="text-sm text-gray-600 leading-relaxed" data-id="element-762">
            <strong data-id="element-763">Disclaimer:</strong> AfriCard Compare is an independent
            comparison tool. We are not affiliated with any of the mentioned
            service providers. Brands and logos displayed belong to their
            respective owners. All financial transactions are made directly
            between you and your chosen provider.
          </p>
        </div>
      </div>
    </>;
}